<template>
  <LayoutPrimary>
    <div :style="containerStyle">
      <AggregatedSkillsViewer />
    </div>
  </LayoutPrimary>
</template>

<script>
  import AggregatedSkillsViewer from '@skill-explorer/modules/aggregated-skills-viewer'
  import LayoutPrimary from '@modules/v2/layout/layout-primary'
  import { Layout } from '@js/styles'

  export default {
    name: 'SkillExplorerView',
    components: {
      AggregatedSkillsViewer,
      LayoutPrimary,
    },
    data: function () {
      return {
        attrs: {
          contentStyle: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          },
        },
        containerStyle: {
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          width: '100%',
        },
      };
    },
    mounted: async function () {
      try {
        this.$store.dispatch('aggregatedSkills/fetchTenantSkills');
      } catch (error) {
        console.error(error);
      }
    },
    beforeDestroy: function () {
      this.$store.commit('aggregatedSkills/initialize');
    },
  };
</script>
